export default {
    setAlertsChecked(state, value) {
        state.alertsChecked = value;
    },
    setUrgentAlertContent(state, value) {
        state.urgentAlertContent = value;
    },
};
